<i18n src='../common_locales.yaml'></i18n>
<i18n>
en:
  search_placeholder: "Search by typing building or street name"
  current_location: "Find my current location"
  fetching_location: "Finding your location..."
  location_error-1: "Please turn on location service"
  location_error-2: "Unable to get your location at the moment"
  location_error-3: "Unable to get your location at the moment"
  drag_help: "Adjust location by dragging the marker"

ja:
  search_placeholder: "場所を検索"
  current_location: "現在位置を利用する"
  fetching_location: "現在位置取得中"
  location_error-1: "現在位置の許可が必要です"
  location_error-2: "現在位置を取得できなかった"
  location_error-3: "現在位置を取得できなかった"
  drag_help: "あなたは赤いマーカーを動かすことができます"
</i18n>


<template lang="pug">
  div
    div.form-group.has-feedback
      input#pac-input.form-control(type="text" ref="autocomplete" v-model="streetName" :placeholder="$t('search_placeholder')" @keyup.enter.stop="$emit('enter')")
      div.mt-2
        a.text-14.text-primary(v-show="!fetchingLocation" v-if="geoLocationAvailable()" @click="getCurrentLocation") {{$t('current_location')}}
        span.text-14.current-location-in-progress(v-show="fetchingLocation")
          icon(name="spinner", spin)
          |  {{$t('fetching_location')}}
    .text-14.error(v-if="locationErrorMessage") {{$t(locationErrorMessage)}}
    .map(ref="mapCanvas")
    p.text-center.text-secondary.mb-2.mt-2(v-if="marker") {{$t('drag_help')}}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DeliveryLocationPicker',
  props: {
    center: {
      default () {
        return [34.673183, 135.504378]
      }
    },
    zoom: {
      default: 5
    },
    location: {
      default: null
    },
    userlocation: {
      default: null
    },
    showDeliveryOverlay: {
      default: false
    }
  },
  data () {
    return {
      // UI Components
      map: null,
      marker: null,
      autocomplete: null,
      fusionTableLayer: null,

      // Data
      pickedLocation: null,
      locationErrorMessage: '',
      streetName: '',
      deliverableRestaurantCoordinates: [],

      // States
      fetchingLocation: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
    pickedLocation (val, oldVal) {
      this.$emit('location-selected', val.lat, val.lng, this.locationName)
    }
  },
  mounted () {
    this.initMap()
    this.initAutocomplete()
    if (this.showDeliveryOverlay) {
      this.initDeliveryOverlay()
    }

    if (this.userLocation) {
      var latlng = new window.google.maps.LatLng(this.userLocation.latitude, this.userLocation.longitude)
      this.addOrUpdateMarker(latlng)
      this.streetName = this.userLocation.name
      this.map.setCenter(latlng)
      this.map.setZoom(18)
    }
  },
  methods: {
    initMap () {
      var mapCanvas = this.$refs.mapCanvas
      const mapOptions = {
        zoom: this.zoom,
        streetViewControl: false,
        fullscreenControl: false,
        center: new window.google.maps.LatLng(...this.center)
      }
      this.map = new window.google.maps.Map(mapCanvas, mapOptions)
    },
    initAutocomplete () {
      var input = this.$refs.autocomplete
      this.autocomplete = new window.google.maps.places.Autocomplete(input)
      this.autocomplete.setComponentRestrictions({'country': ['jp']})
      this.autocomplete.addListener('place_changed', () => {
        let place = this.autocomplete.getPlace()
        if (place.geometry) {
          this.locationName = place.name || place.formatted_address
          this.streetName = place.name || place.formatted_address
          this.map.setCenter(place.geometry.location)
          this.map.setZoom(18)
          this.addOrUpdateMarker(place.geometry.location)

          this.pickedLocation = {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()}
        }
      })
    },
    initDeliveryOverlay () {
      this.fusionTableLayer = new window.google.maps.FusionTablesLayer({
        query: {
          select: 'name',
          from: process.env.FUSION_TABLE,
          where: 'name >= 1'
        },
        styles: [{
          polygonOptions: {
            fillColor: '#90ee90',
            strokeWeight: '0',
            fillOpacity: 0.3
          }
        }]
      })
      this.fusionTableLayer.setMap(this.map)
    },
    addOrUpdateMarker (latlng) {
      if (!this.marker) {
        this.marker = new window.google.maps.Marker({
          title: 'Drag to set location',
          position: latlng,
          optimized: false,
          map: this.map,
          draggable: true
        })
        window.google.maps.event.addListener(this.marker, 'dragend', () => {
          var latlng = this.marker.getPosition()
          this.updateAddressInput(latlng)

          this.pickedLocation = {lat: latlng.lat(), lng: latlng.lng()}
        })
      } else {
        this.updateAddressInput(latlng)
        this.marker.setPosition(latlng)
      }
    },
    updateAddressInput (latlng) {
      var geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({'location': latlng}, (results, status) => {
        this.fetchingLocation = false
        if (status === 'OK') {
          if (results[0]) {
            // console.log(JSON.stringify(results[0]))
            this.locationName = results[0].formatted_address
            this.streetName = results[0].formatted_address

            this.pickedLocation = {lat: latlng.lat(), lng: latlng.lng()}
          }
        }
      })
    },
    geoLocationAvailable () {
      return 'geolocation' in navigator
    },
    getCurrentLocation () {
      this.fetchingLocation = true
      navigator.geolocation.getCurrentPosition(
        position => {
          var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude)

          this.map.setCenter(latlng)
          this.map.setZoom(18)
          this.addOrUpdateMarker(latlng)
          this.pickedLocation = latlng
          this.updateAddressInput(latlng)
        },
        error => {
          this.fetchingLocation = false
          console.log('GEOLOCATION ERROR(' + error.code + '): ' + error.message)
          this.locationErrorMessage = 'location_error-' + error.code
        }
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
.current-location-in-progress
  color: gray

.error
  color: red

.map
  width: auto
  height: 300px
  margin: 0 auto
  background: gray
</style>



// WEBPACK FOOTER //
// src/components/DeliveryLocationPicker.vue